import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Navigation from "../components/Navigation";

const BillingSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(5);
  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/billing");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <>
      <Navigation />
      <div className="min-h-screen bg-[#0a0b0f] bg-grid-pattern relative overflow-hidden flex items-center justify-center px-4">
        <div className="absolute inset-0 bg-radial-gradient pointer-events-none" />

        <div className="relative w-full max-w-md text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-emerald-500/20 border border-emerald-500/30 mb-6">
            <svg className="w-8 h-8 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>

          <h1 className="text-3xl font-bold text-zinc-100 mb-3">Payment Successful</h1>
          <p className="text-zinc-400 mb-8">
            Your payment has been processed. Your account will be updated shortly.
          </p>

          {sessionId && (
            <div className="text-xs text-zinc-600 mb-6 break-all">
              Session: {sessionId}
            </div>
          )}

          <div className="space-y-3">
            <button
              onClick={() => navigate("/billing")}
              className="btn-primary w-full py-3 rounded-xl text-sm font-semibold"
            >
              Go to Billing
            </button>
            <p className="text-sm text-zinc-500">
              Redirecting in {countdown} seconds...
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default BillingSuccess;
